export default __webpack_public_path__ + "static/media/LS-EV-Community.48562511.svg";